import React from 'react';
import { connect } from 'unistore/react';
import dateFormat from 'date-fns/format';

import IfElse from '../../../components/IfElse';

import { moneyFormatter } from '@utils/customLib';
import { getCurrencyFromCode, getCurrencyProperty } from '@utils/params';

import { getConvRate } from '@utils/storeUtils';

const TradeRow = ({
	currentTradingCoin: { market_id },
	currentShownCurrency,
	time,
	rate,
	difference,
	inrDecimals,
}) => {
	const sym = getCurrencyProperty(
		getCurrencyFromCode(currentShownCurrency),
		'sym'
	);
	let textColor = '';
	const highlightColor = rate !== '-' && 'u-highlight-target';
	const timeObj = new Date(
		time.includes('Z') ? time : `${time.split(' ').join('T')}+05:30`
	);

	const shownRate = rate * getConvRate(market_id, currentShownCurrency);
	const shownDiff = difference * getConvRate(market_id, currentShownCurrency);

	if (difference > 0) {
		textColor = 'text-jungleGreen';
		// highlightColor = 'u-highlight-target--green';
	}
	if (difference < 0) {
		textColor = 'text-pastelRed';
		// highlightColor = 'u-highlight-target--red';
	}

	return (
		<tr className="c-table__row c-table__row--altColored">
			<td
				className={`c-table__cell relative ${highlightColor} bb-list__timecell u-text-spacing--1 u-monospaced`}
				title={
					time !== '-'
						? dateFormat(timeObj, 'HH:mm:ss dd-MMM-yy (zzzz)')
						: '-'
				}
			>
				{time !== '-'
					? dateFormat(timeObj, "HH:mm:ss 'IST', dd MMM")
					: '-:-:-'}
			</td>
			<td
				className={`c-table__cell relative text-right ${highlightColor} u-text-spacing--1 u-monospaced`}
			>
				{sym}
				{moneyFormatter(shownRate, {
					minimumFractionDigits: inrDecimals,
					maximumFractionDigits: inrDecimals,
				})}
			</td>
			<td
				className={`c-table__cell relative text-right ${highlightColor} ${textColor} u-text-spacing--1 u-monospaced`}
			>
				<IfElse
					condition={difference > 0}
					then={<b>&uarr;</b>}
					else={
						<IfElse
							condition={difference < 0}
							then={<b>&darr;</b>}
							else={null}
						/>
					}
				/>
				{moneyFormatter(Math.abs(shownDiff), {
					minimumFractionDigits: inrDecimals,
					maximumFractionDigits: inrDecimals,
				})}
			</td>
		</tr>
	);
};

export default connect(
	'openOrders, currentTradingCoin, convRates, currentShownCurrency'
)(TradeRow);
